export default __webpack_public_path__ + "static/media/grocery-logo.e2de44f2.svg";